.root {
  overflow: auto;
}

.divider {
  margin-top: 8px;
  margin-bottom: 8px;
}

.metaSection {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.metaRow {
  display: flex;
  justify-content: space-between;
}
